"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isExternal = isExternal;
exports.isvalidUsername = isvalidUsername;
exports.validUsername = validUsername;
exports.validatAlphabets = validatAlphabets;
exports.validateCascadeRule = validateCascadeRule;
exports.validateIncludeMaxInputNumRule = validateIncludeMaxInputNumRule;
exports.validateIncludeMaxLength = validateIncludeMaxLength;
exports.validateIncludeMaxValue = validateIncludeMaxValue;
exports.validateIncludeMinInputNumRule = validateIncludeMinInputNumRule;
exports.validateIncludeMinLength = validateIncludeMinLength;
exports.validateIncludeMinValue = validateIncludeMinValue;
exports.validateLowerCase = validateLowerCase;
exports.validateMaxDecimalDigitsRule = validateMaxDecimalDigitsRule;
exports.validateMaxInputNumRule = validateMaxInputNumRule;
exports.validateMaxLength = validateMaxLength;
exports.validateMaxValue = validateMaxValue;
exports.validateMinDecimalDigitsRule = validateMinDecimalDigitsRule;
exports.validateMinInputNumRule = validateMinInputNumRule;
exports.validateMinLength = validateMinLength;
exports.validateMinValue = validateMinValue;
exports.validateRegex = validateRegex;
exports.validateURL = validateURL;
exports.validateUpperCase = validateUpperCase;
exports.validateValueType = validateValueType;
require("core-js/modules/es6.regexp.constructor");
require("core-js/modules/es6.number.constructor");
/**
 * Created by jiachenpan on 16/11/18.
 */
/**
 * @param {string} path
 * @returns {Boolean}
 */
function isExternal(path) {
  return /^(https?:|mailto:|tel:)/.test(path);
}

/**
 * @param {string} str
 * @returns {Boolean}
 */
function validUsername(str) {
  var valid_map = ['admin', 'editor'];
  return valid_map.indexOf(str.trim()) >= 0;
}
function isvalidUsername(str) {
  if (str && str.length > 3 && str.length < 64) {
    return true;
  }
  return false;
}

/* 合法uri*/
function validateURL(textval) {
  var urlregex = /^(https?|ftp):\/\/([a-zA-Z0-9.-]+(:[a-zA-Z0-9.&%$-]+)*@)*((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9][0-9]?)(\.(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9]?[0-9])){3}|([a-zA-Z0-9-]+\.)*[a-zA-Z0-9-]+\.(com|edu|gov|int|mil|net|org|biz|arpa|info|name|pro|aero|coop|museum|[a-zA-Z]{2}))(:[0-9]+)*(\/($|[a-zA-Z0-9.,?'\\+&%$#=~_-]+))*$/;
  return urlregex.test(textval);
}

/* 小写字母*/
function validateLowerCase(str) {
  var reg = /^[a-z]+$/;
  return reg.test(str);
}

/* 大写字母*/
function validateUpperCase(str) {
  var reg = /^[A-Z]+$/;
  return reg.test(str);
}

/* 大小写字母*/
function validatAlphabets(str) {
  var reg = /^[A-Za-z]+$/;
  return reg.test(str);
}
/*
  value : 要验证的值
  content: 规则限定的值的最大长度(包含最大长度)
 */
function validateIncludeMaxLength(value, ruleValue) {
  var flag = true;
  var message = '';
  if (value == '' || value == undefined || value == null) {
    return {
      status: flag,
      message: message
    };
  }
  if (value.trim().length > ruleValue) {
    flag = false;
    message = "最多可填写" + ruleValue + "位";
  }
  var ruleResult = {
    status: flag,
    message: message
  };
  return ruleResult;
}
/*
  value : 要验证的值
  content: 规则限定的值的最大长度(不包含最大长度)
 */
function validateMaxLength(value, ruleValue) {
  var flag = true;
  var message = '';
  if (value.trim().length >= ruleValue) {
    flag = false;
    message = "最多可填写" + (ruleValue - 1) + "位";
  }
  var ruleResult = {
    status: flag,
    message: message
  };
  return ruleResult;
}
/*
  value : 要验证的值
  content: 规则限定的值的最小长度(包含最小长度)
 */
function validateIncludeMinLength(value, ruleValue) {
  var flag = true;
  var message = '';
  if (value.trim().length < ruleValue) {
    flag = false;
    message = "最少需填写" + ruleValue + "位";
  }
  var ruleResult = {
    status: flag,
    message: message
  };
  return ruleResult;
}
/*
  value : 要验证的值
  content: 规则限定的值的最小长度(包含最小长度)
 */
function validateMinLength(value, ruleValue) {
  var flag = true;
  var message = '';
  if (value.trim().length <= ruleValue) {
    flag = false;
    message = "最少需填写" + (ruleValue + 1) + "位";
  }
  var ruleResult = {
    status: flag,
    message: message
  };
  return ruleResult;
}
/*
  value : 要验证的值
  content: 规则限定的最大值(包含最大值)
 */
function validateIncludeMaxValue(value, ruleValue) {
  var flag = true;
  var message = '';
  if (Number(value.trim()) > Number(ruleValue)) {
    flag = false;
    message = "最大值为" + Number(ruleValue);
  }
  var ruleResult = {
    status: flag,
    message: message
  };
  return ruleResult;
}
/*
  value : 要验证的值
  content: 规则限定的最大值(不包含最大值)
 */
function validateMaxValue(value, ruleValue) {
  var flag = true;
  var message = '';
  if (Number(value.trim()) >= Number(ruleValue)) {
    flag = false;
    message = "最大值为" + Number(ruleValue + 1);
  }
  var ruleResult = {
    status: flag,
    message: message
  };
  return ruleResult;
}
/*
  value : 要验证的值
  content: 规则限定的最小值(包含最小值)
 */
function validateIncludeMinValue(value, ruleValue) {
  var flag = true;
  var message = '';
  if (Number(value.trim()) < Number(ruleValue)) {
    flag = false;
    message = "最小值为" + Number(ruleValue);
  }
  var ruleResult = {
    status: flag,
    message: message
  };
  return ruleResult;
}
/*
  value : 要验证的值
  content: 规则限定的最小值(不包含最小值)
 */
function validateMinValue(value, ruleValue) {
  var flag = true;
  var message = '';
  if (Number(value.trim()) <= Number(ruleValue)) {
    flag = false;
    message = "最小值为" + Number(rule.ruleValue - 1);
  }
  var ruleResult = {
    status: flag,
    message: message
  };
  return ruleResult;
}
/*
  value :要验证的值
  content: 规则限定的多选或多复杂类型最多能选的个数(包含最大值)
 */
function validateIncludeMaxInputNumRule(value, ruleValue) {
  var flag = true;
  var message = '';
  if (Number(value) > Number(ruleValue)) {
    flag = false;
    message = "最多可选" + ruleValue + "个";
  }
  var ruleResult = {
    status: flag,
    message: message
  };
  return ruleResult;
}
/*
  value :要验证的值
  从content: 规则限定的多选或多复杂类型最多能选的个数（不包含最大值）
 */
function validateMaxInputNumRule(value, ruleValue) {
  var flag = true;
  var message = '';
  if (Number(value) >= Number(ruleValue)) {
    flag = false;
    message = "最多可选" + (ruleValue - 1) + "个";
  }
  var ruleResult = {
    status: flag,
    message: message
  };
  return ruleResult;
}
/*
  value :要验证的值
  content: 规则限定的多选或多复杂类型最少能选的个数(包含最小值)
 */
function validateIncludeMinInputNumRule(value, ruleValue) {
  var flag = true;
  var message = '';
  if (Number(value) < Number(ruleValue)) {
    flag = false;
    message = "最少可选" + ruleValue + "个";
  }
  var ruleResult = {
    status: flag,
    message: message
  };
  return ruleResult;
}
/*
  value :要验证的值
  content: 规则限定的多选或多复杂类型最少能选的个数(不包含最小值)
 */
function validateMinInputNumRule(value, ruleValue) {
  var flag = true;
  var message = '';
  if (Number(value) <= Number(ruleValue)) {
    flag = false;
    message = "最少可选" + (ruleValue + 1) + "个";
  }
  var ruleResult = {
    status: flag,
    message: message
  };
  return ruleResult;
}
/*
  value : 要验证的值
  content: 值类型是否符合规则标准
 */
function validateValueType(value, ruleValue) {
  var flag = true;
  var message = '';
  if (ruleValue == 'text') {} else if (ruleValue == 'decimal') {
    var reg = new RegExp('[1-9]\d*\.\d*|0\.\d*[1-9]\d*');
    if (!reg.test(value.trim())) {
      flag = false;
      message = "要求必须是小数";
    }
  } else if (ruleValue == 'url') {
    var reg = new RegExp('http://([\\w-]+\\.)+[\\w-]+(/[\\w-./?%&=]*)?');
    if (!reg.test(value.trim())) {
      flag = false;
      message = "要求必须是url";
    }
  }
  var ruleResult = {
    status: flag,
    message: message
  };
  return ruleResult;
}
/*
  value :要验证的值
  content: 规则中的正则表达式
 */
function validateRegex(value, ruleValue) {
  var reg = new RegExp(ruleValue);
  var flag = true;
  var message = '';
  if (!reg.test(value.trim())) {
    flag = false;
    message = '不符合规范';
  }
  var ruleResult = {
    status: flag,
    message: message
  };
  return ruleResult;
}
/*
  value :要验证的值
  content: 规则中的小数点最多几位
 */
function validateMaxDecimalDigitsRule(value, ruleValue) {}
/*
   value :要验证的值
   content: 规则中的小数点最少几位
 */
function validateMinDecimalDigitsRule(value, ruleValue) {}
/*
   value :要验证的值
   content ：级联类型的值
 */
function validateCascadeRule(value, ruleValue) {}